module.exports = __webpack_public_path__ + "static/media/DreamHouseLogo2.e23a4db6.webp";